import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isDashboardSelector, templateTypeSelector } from '@selectors/page';
import {
    showSnapAssistantReminder,
    hideSnapAssistantReminder,
} from '@actions/page';
import { addNotification } from '@components/GlobalNotification/globalNotification.actions';
import { getCurrentPackage } from '@actions/packages.actions';
import http from '../../core/fetch';
import './Page.scss';

class Page extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDashboardRoute: false,
        };

        if (window.ga) {
            window.ga('send', 'pageview', window.location.pathname);
        }
    }

    componentDidMount() {
        const { location, getCurrentPackage } = this.props;

        if (location.pathname === '/') {
            this.setState({ isDashboardRoute: true });
        }

        getCurrentPackage();

        if(this.state.isDashboardRoute && this.props.shouldRenderReminder) {
            this.showReminderTimeout = setTimeout(() => {
                this.props.showSnapAssistantReminder();
            }, 3000);
            this.hideReminderTimeout = setTimeout(() => {
                this.closeReminderAd();
                this.props.hideSnapAssistantReminder();
            }, 8000);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.showReminderTimeout);
        clearTimeout(this.hideReminderTimeout);
    }

    componentDidUpdate(prevProps) {
        if ( this.props.location.pathname !== prevProps.location.pathname ) {
            this.setState({isDashboardRoute: this.props.location.pathname === '/'});
        }

        if (prevProps.isNotificationShown !== this.props.isNotificationShown && this.props.isNotificationShown) {
            this.props.showNotification({ text: 'File successfully uploaded', duration: 5000 })
        }
    }

    closeReminderAd() {
        let { ads } = window.pageData;
        const indexOfAd = ads.indexOf('addExtension');

        const params = {
            ads: ['addExtension'],
        };

        http.post('close ad', {}, {
            body: JSON.stringify(params),
            headers: {
                'content-type': 'application/json; charset=utf-8',
            },
        });

        if (indexOfAd !== -1) {
            ads.splice(indexOfAd, 1);
        }
    }


    render() {
        const { children, templateType, isDashboard, className } = this.props;
        let classList = ['container', 'page-container', templateType, className];

        if (!isDashboard) {
            classList.push('page--collapsed');
        }


        classList = classList.join(' ');
        return (
            <div className={classList}>
                { children }
            </div>
        );
    }
}

Page.propTypes = {
    children: PropTypes.element,
    isDashboard: PropTypes.bool,
    isNotificationShown: PropTypes.bool,
    templateType: PropTypes.string,
    location: PropTypes.object,
    getCurrentPackage: PropTypes.func,
    showNotification: PropTypes.func,
    className: PropTypes.string,
    shouldRenderReminder: PropTypes.bool,
    showSnapAssistantReminder: PropTypes.func,
    hideSnapAssistantReminder: PropTypes.func,
};

Page.defaultProps = {};

const mapStateToProps = state => ({
    isDashboard: isDashboardSelector(state),
    templateType: templateTypeSelector(state),
    isNotificationShown: state.pageStatus.showNotification,
    shouldRenderReminder: state.pageStatus.shouldRenderReminder,
});

const mapDispatchToProps = dispatch => ({
    getCurrentPackage: () => dispatch(getCurrentPackage()),
    showNotification: text => dispatch(addNotification(text)),
    hideSnapAssistantReminder: () => dispatch(hideSnapAssistantReminder()),
    showSnapAssistantReminder: () => dispatch(showSnapAssistantReminder()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));
